import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useState, useEffect } from "react";
import { useOtpSettings } from "./OtpContext";
import Divider from "@mui/material/Divider";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FormAddress from "../components/formAddress";
import { Modal } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function StudentForm({
  studentData,
  onClose,
  fetchStudnt,
  handleSubmit,
  oldPaymentData,
  searchOldPaymentData,
  academicYearId,
  gradeName,
  gradeNameSearch,
  sectionNameSearch,
  feesSlabSearch,
  gradeAdmissionName,
  gradeAdmissionNameSearch,
  sectionName,
  feesSlabName,
  userId,
  userMail,
  transportSlab,
  transportSlabSearch,
  grades: gradesProp = [],          // ← add
  gradeAdmission: gradeAdmissionProp = [],  // ← add
  sections: sectionsProp = [],      // ← add
  feeSlab: feeSlabProp = [],        // ← add
  transportFees: transportFeesProp = [],    // ← add
}) {

  // ✅ ADD these — use prop values directly
  const grades = gradesProp;
  const gradeAdmission = gradeAdmissionProp;
  const sections = sectionsProp;
  const feeSlab = feeSlabProp;
  const transportFees = transportFeesProp;
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ rte: false });
  const [addressData, setAddressData] = useState([]);
  const [years, setYears] = useState([]);
  const [emailError, setEmailError] = useState("");
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [borderColor, setBorderColor] = useState("#0A64A2");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [genderError, setGenderError] = useState(false);
  const [feeSlabError, setFeeSlabError] = useState(false);
  const [gradeError, setGradeError] = useState(false);
  const [mobileNoError, setMobileNoError] = useState(false);
  const currentYear = new Date().getFullYear();
  const today = new Date().toISOString().split("T")[0];
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  // const [email, setEmail] = useState(process.env.REACT_APP_EMAIL);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1); // Counter for resend attempts
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [addressFlag1, setAddressFlag1] = useState(false);
  const [addressFlag2, setAddressFlag2] = useState(false);
  const [addressFlag3, setAddressFlag3] = useState(false);
  const [documentFlag1, setDocumentFlag1] = useState(false);
  const [documentFlag2, setDocumentFlag2] = useState(false);
  const [documentFlag3, setDocumentFlag3] = useState(false);
  const [documentFlag4, setDocumentFlag4] = useState(false);
  const [documentFlag5, setDocumentFlag5] = useState(false);
  const [documentFlag6, setDocumentFlag6] = useState(false);
  const [documentFlag7, setDocumentFlag7] = useState(false);
  const [documentFlag8, setDocumentFlag8] = useState(false);
  const [documentFlag9, setDocumentFlag9] = useState(false);
  const [documentFlag10, setDocumentFlag10] = useState(false);
  const [documentFlag11, setDocumentFlag11] = useState(false);
  const [selectedGradeName, setSelectedGradeName] = useState();
  const [selectedGradeAdmissionName, setSelectedGradeAdmissionName] =
    useState();
  const [selectedSectionName, setSelectedSectionName] = useState();
  const [selectedFeesSlabName, setSelectedFeesSlabName] = useState();
  const [selectedTransportSlab, setSelectedTransportSlab] = useState();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  const navigate = useNavigate();

   const instituteId = localStorage.getItem("instituteId");
    const instituteEmailMap = {
      "1": process.env.REACT_APP_EMAIL_JHS,
      "2": process.env.REACT_APP_EMAIL_JPS,
    };
    const [email, setEmail] = useState(instituteEmailMap[instituteId]);

  const inputBorder = {
    mb: 1,
    pt: 0,
    pb: 0,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `1px solid  ${borderColor}`,
      },
    },
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/role/getrole",
        );

        setRoles(response.data);
        console.log("Roles fetched successfully:", response.data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    fetchRoles();
  }, []);

  const normalizeRteValue = (value) => {
    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return value; // Return the original value if it is neither boolean nor "true"/"false" strings
  };

  const { isOtpEnabled } = useOtpSettings();

  const handleGetOtp = async () => {
    // Check if OTP is enabled for StudentForm
    const otpRequiredForStudentForm = isOtpEnabled('StudentForm');
    
 if (!otpRequiredForStudentForm) {
  const old = oldPaymentData || searchOldPaymentData || {};

  const hasChanges =
    String(old.first_name ?? "") !== String(formData.first_name ?? "") ||
    String(old.last_name ?? "") !== String(formData.last_name ?? "") ||
    String(old.middle_name ?? "") !== String(formData.middle_name ?? "") ||
    String(old.date_of_birth ?? "") !== String(formData.date_of_birth ?? "") ||
    String(old.gender ?? "") !== String(formData.gender ?? "") ||
    String(old.contact_no ?? "") !== String(formData.contact_no ?? "") ||
    String(old.email_id ?? "") !== String(formData.email_id ?? "") ||
    String(old.grade_id ?? "") !== String(formData.grade_id ?? "") ||
    String(old.section_id ?? "") !== String(formData.section_id ?? "") ||
    String(old.fee_slab_id ?? "") !== String(formData.fee_slab_id ?? "") ||
    String(old.transport_slab_id ?? "") !== String(formData.transport_slab_id ?? "") ||
    String(old.blood_group ?? "") !== String(formData.blood_group ?? "") ||
    String(old.caste ?? "") !== String(formData.caste ?? "") ||
    String(old.remarks ?? "") !== String(formData.remarks ?? "") ||
    String(old.father_name ?? "") !== String(formData.father_name ?? "") ||
    String(old.mother_name ?? "") !== String(formData.mother_name ?? "") ||
    String(old.guardian_name ?? "") !== String(formData.guardian_name ?? "") ||
    String(old.student_aadhar_no ?? "") !== String(formData.student_aadhar_no ?? "") ||
    String(old.sat_no ?? "") !== String(formData.sat_no ?? "") ||
    String(old.apaar_id ?? "") !== String(formData.apaar_id ?? "") ||
    String(old.gr_number ?? "") !== String(formData.gr_number ?? "") ||
    String(old.year_of_admission ?? "") !== String(formData.year_of_admission ?? "") ||
    String(old.grade_of_admission ?? "") !== String(formData.grade_of_admission ?? "") ||
    String(old.place_of_birth ?? "") !== String(formData.place_of_birth ?? "") ||
    String(old.rte ?? "") !== String(formData.rte ?? "") ||
    String(old.pen_no ?? "") !== String(formData.pen_no ?? "") ||
    String(old.mother_tongue ?? "") !== String(formData.mother_tongue ?? "") ||
    String(old.nationality ?? "") !== String(formData.nationality ?? "") ||
    String(old.father_occupation ?? "") !== String(formData.father_occupation ?? "") ||
    String(old.mother_occupation ?? "") !== String(formData.mother_occupation ?? "") ||
    String(old.guardian_occupation ?? "") !== String(formData.guardian_occupation ?? "") ||
    String(old.father_aadhar_no ?? "") !== String(formData.father_aadhar_no ?? "") ||
    String(old.mother_aadhar_no ?? "") !== String(formData.mother_aadhar_no ?? "") ||
    String(old.guardian_aadhar_no ?? "") !== String(formData.guardian_aadhar_no ?? "") ||
    String(old.father_contact_no ?? "") !== String(formData.father_contact_no ?? "") ||
    String(old.mother_contact_no ?? "") !== String(formData.mother_contact_no ?? "") ||
    String(old.guardian_contact_no ?? "") !== String(formData.guardian_contact_no ?? "") ||
    String(old.role_id ?? "") !== String(formData.role_id ?? "") ||
    String(old.academic_year_id ?? "") !== String(formData.academic_year_id ?? "") ||
    String(old.role_id ?? "") !== String(formData.role_id ?? "") ||
    
    addressFlag1 || addressFlag2 || addressFlag3 ||
    documentFlag1 || documentFlag2 || documentFlag3 || documentFlag4 ||
    documentFlag5 || documentFlag6 || documentFlag7 || documentFlag8 ||
    documentFlag9 || documentFlag10 || documentFlag11;

  console.log("hasChanges:", hasChanges);

  if (!hasChanges) {
    setSnackbarMessage("No changes detected.");
    setSnackbarMessageColor("error");
    setShowSnackbarMessage(true);
    return;
  }

  saveStudent();
  return;
}
    
    setSnackbarMessage("OTP sent successfully.");
    setSnackbarMessageColor("success");
    setShowSnackbarMessage(true);
    
    try {
      // Populate paymentDetails with formatted addresses
      const normalizeValue = (value) => (value == null ? "" : value); // Converts null or undefined to ""

      const paymentDetails = {
        first_name: normalizeValue(formData.first_name),
        middle_name: normalizeValue(formData.middle_name),
        last_name: normalizeValue(formData.last_name),
        date_of_birth: normalizeValue(formData.date_of_birth),
        place_of_birth: normalizeValue(formData.place_of_birth),
        gender: normalizeValue(formData.gender),
        contact_no: normalizeValue(formData.contact_no),
        blood_group: normalizeValue(formData.blood_group),
        caste: normalizeValue(formData.caste),
        email_id: normalizeValue(formData.email_id),
        student_aadhar_no: normalizeValue(formData.student_aadhar_no),
        sat_no: normalizeValue(formData.sat_no),
        pen_no: normalizeValue(formData.pen_no),
        fee_slab_id: selectedFeesSlabName,
        mother_tongue: normalizeValue(formData.mother_tongue),
        nationality: normalizeValue(formData.nationality),
        grade_name: selectedGradeName,
        section_name: selectedSectionName,
        gr_number: normalizeValue(formData.gr_number),
        year_of_admission: normalizeValue(formData.year_of_admission),
        grade_of_admission: selectedGradeAdmissionName,
        father_name: normalizeValue(formData.father_name),
        father_occupation: normalizeValue(formData.father_occupation),
        father_aadhar_no: normalizeValue(formData.father_aadhar_no),
        father_contact_no: normalizeValue(formData.father_contact_no),
        mother_name: normalizeValue(formData.mother_name),
        mother_occupation: normalizeValue(formData.mother_occupation),
        mother_aadhar_no: normalizeValue(formData.mother_aadhar_no),
        mother_contact_no: normalizeValue(formData.mother_contact_no),
        guardian_name: normalizeValue(formData.guardian_name),
        guardian_occupation: normalizeValue(formData.guardian_occupation),
        guardian_aadhar_no: normalizeValue(formData.guardian_aadhar_no),
        guardian_contact_no: normalizeValue(formData.guardian_contact_no),
        role_id: normalizeValue(formData.role_id),
        academic_year_id: normalizeValue(formData.academic_year_id),
        remarks: normalizeValue(formData.remarks),
        rte: normalizeRteValue(formData.rte),
        apaar_id: normalizeValue(formData.apaar_id),
        transport_slab_id: selectedTransportSlab,
      };

      const oldPaymentDetails = {
        first_name: normalizeValue(
          oldPaymentData?.first_name || searchOldPaymentData?.first_name,
        ),
        middle_name: normalizeValue(
          oldPaymentData?.middle_name || searchOldPaymentData?.middle_name,
        ),
        last_name: normalizeValue(
          oldPaymentData?.last_name || searchOldPaymentData?.last_name,
        ),
        date_of_birth: normalizeValue(
          oldPaymentData?.date_of_birth || searchOldPaymentData?.date_of_birth,
        ),
        place_of_birth: normalizeValue(
          oldPaymentData?.place_of_birth ||
            searchOldPaymentData?.place_of_birth,
        ),
        gender: normalizeValue(
          oldPaymentData?.gender || searchOldPaymentData?.gender,
        ),
        contact_no: normalizeValue(
          oldPaymentData?.contact_no || searchOldPaymentData?.contact_no,
        ),
        blood_group: normalizeValue(
          oldPaymentData?.blood_group || searchOldPaymentData?.blood_group,
        ),
        caste: normalizeValue(
          oldPaymentData?.caste || searchOldPaymentData?.caste,
        ),
        email_id: normalizeValue(
          oldPaymentData?.email_id || searchOldPaymentData?.email_id,
        ),
        student_aadhar_no: normalizeValue(
          oldPaymentData?.student_aadhar_no ||
            searchOldPaymentData?.student_aadhar_no,
        ),
        sat_no: normalizeValue(
          oldPaymentData?.sat_no || searchOldPaymentData?.sat_no,
        ),
        pen_no: normalizeValue(
          oldPaymentData?.pen_no || searchOldPaymentData?.pen_no,
        ),
        fee_slab_id: normalizeValue(feesSlabName || feesSlabSearch),
        mother_tongue: normalizeValue(
          oldPaymentData?.mother_tongue || searchOldPaymentData?.mother_tongue,
        ),
        nationality: normalizeValue(
          oldPaymentData?.nationality || searchOldPaymentData?.nationality,
        ),
        grade_name: normalizeValue(gradeName || gradeNameSearch),
        section_name: normalizeValue(sectionName || sectionNameSearch),
        gr_number: normalizeValue(
          oldPaymentData?.gr_number || searchOldPaymentData?.gr_number,
        ),
        year_of_admission: normalizeValue(
          oldPaymentData?.year_of_admission ||
            searchOldPaymentData?.year_of_admission,
        ),
        grade_of_admission: normalizeValue(
          gradeAdmissionName || gradeAdmissionNameSearch,
        ),
        father_name: normalizeValue(
          oldPaymentData?.father_name || searchOldPaymentData?.father_name,
        ),
        father_occupation: normalizeValue(
          oldPaymentData?.father_occupation ||
            searchOldPaymentData?.father_occupation,
        ),
        father_aadhar_no: normalizeValue(
          oldPaymentData?.father_aadhar_no ||
            searchOldPaymentData?.father_aadhar_no,
        ),
        father_contact_no: normalizeValue(
          oldPaymentData?.father_contact_no ||
            searchOldPaymentData?.father_contact_no,
        ),
        mother_name: normalizeValue(
          oldPaymentData?.mother_name || searchOldPaymentData?.mother_name,
        ),
        mother_occupation: normalizeValue(
          oldPaymentData?.mother_occupation ||
            searchOldPaymentData?.mother_occupation,
        ),
        mother_aadhar_no: normalizeValue(
          oldPaymentData?.mother_aadhar_no ||
            searchOldPaymentData?.mother_aadhar_no,
        ),
        mother_contact_no: normalizeValue(
          oldPaymentData?.mother_contact_no ||
            searchOldPaymentData?.mother_contact_no,
        ),
        guardian_name: normalizeValue(
          oldPaymentData?.guardian_name || searchOldPaymentData?.guardian_name,
        ),
        guardian_occupation: normalizeValue(
          oldPaymentData?.guardian_occupation ||
            searchOldPaymentData?.guardian_occupation,
        ),
        guardian_aadhar_no: normalizeValue(
          oldPaymentData?.guardian_aadhar_no ||
            searchOldPaymentData?.guardian_aadhar_no,
        ),
        guardian_contact_no: normalizeValue(
          oldPaymentData?.guardian_contact_no ||
            searchOldPaymentData?.guardian_contact_no,
        ),
        role_id: normalizeValue(
          oldPaymentData?.role_id || searchOldPaymentData?.role_id,
        ),
        academic_year_id: normalizeValue(
          oldPaymentData?.academic_year_id ||
            searchOldPaymentData?.academic_year_id,
        ),
        remarks: normalizeValue(
          oldPaymentData?.remarks || searchOldPaymentData?.remarks,
        ),
        rte: normalizeRteValue(
          oldPaymentData?.rte || searchOldPaymentData?.rte || false,
        ),
        apaar_id: normalizeValue(
          oldPaymentData?.apaar_id || searchOldPaymentData?.apaar_id,
        ),
        transport_slab_id: normalizeValue(transportSlab || transportSlabSearch),
        // address: addressFlag ,
        // document: documentFlag ,
      };

      const paymentType = "Student Details";
      const paymentId = formData.student_id;

      setEmail(process.env.REACT_APP_EMAIL);
      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/send-otp/getOtp",
        {
          email,
          userMail,
          paymentId,
          updatedPaymentDetails: paymentDetails,
          oldPaymentDetails: oldPaymentDetails,
          userId,
          paymentType,
          studentName: formData.first_name + " " + formData.last_name,
          gradeName: selectedGradeName || gradeName,
          sectionName: sectionName || sectionNameSearch,
          addressFlag1,
          addressFlag2,
          addressFlag3,
          documentFlag1,
          documentFlag2,
          documentFlag3,
          documentFlag4,
          documentFlag5,
          documentFlag6,
          documentFlag7,
          documentFlag8,
          documentFlag9,
          documentFlag10,
          documentFlag11,
          created_by: userId,
        },
        { withCredentials: "true" },
      );
      // ✅ Handle Unauthorized Access Immediately
      if (response.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // ✅ Fixed spelling from "signin" to "signin"
        return; // Stop further execution
      }
      console.log(response.data.message);
      if (response.data.otp) {
        // setBackendOtp(response.data.otp);
        // setOtpSent(true);
        // setResendTimer(600);
        // setCanResend(false);
        // setOtp(["", "", "", "", "", ""]);
        // console.log("otp", paymentDetails);
        // setIsOtpModalOpen(true);

        setBackendOtp(response.data.otp);
        setOtpSent(true);
        setResendTimer(600);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        setIsOtpModalOpen(true);
        // ✅ ADD THIS — only show success after OTP is confirmed sent
        setSnackbarMessage("OTP sent successfully.");
        setSnackbarMessageColor("success");
        setShowSnackbarMessage(true);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setIsOtpModalOpen(false);
      setSnackbarMessageColor("error");
      setSnackbarMessage("No changes detected.");
      setShowSnackbarMessage(true);
      if (error.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // ✅ Fix: Ensure correct spelling
        return;
      }
    }
  };
  console.log("studen daata", studentData);
  const handleVerifyOtp = async (event) => {
    // event.preventDefault();
    if (event?.preventDefault) {
      event.preventDefault();
    }
    const enteredOtp = otp.join(""); // Combine the entered OTP from the input boxes

    // Check if the OTP field is empty
    if (!enteredOtp) {
      setVerifyOTPMsg("Please enter the OTP");
      return;
    }

    // Check if the entered OTP matches the backend OTP
    if (enteredOtp === backendOtp) {
      // setVerifyOTPMsg("OTP Verified Successfully");
      const studentRole = roles.find((r) => r.role_name === "Student");
      const combinedData = {
        ...formData,
        address: addressData,
        documents: selectedDocuments,
        role_id: studentRole ? studentRole.role_id : null, // Set role_id based on the "Student" role
        updated_by: userId,
        updated_timestamp: new Date(),
        year_of_admission: formData.year_of_admission,
      };

      try {
        // Await the axios POST request to save the student data
        const response = await axios.post(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/student/save-student",
          combinedData,
          { withCredentials: true },
        );
        console.log("Student created successfully:", response.data);

        if (response.status === 401) {
          console.warn("Unauthorized access. Redirecting to Sign In...");
          navigate("/signin");
          return; // Stop further execution
        }

        // Check if studentData exists and show appropriate message
        if (studentData) {
          handleSubmit("Student Updated Successfully", "success");
        } else {
          handleSubmit("Student Created Successfully", "success");
        }

        reset();
      } catch (error) {
        console.log("Error response:", error.response);

        if (
          error.response.status === 409 &&
          error.response.data?.message ===
            "This Aadhar number is already registered with another student."
        ) {
          handleSubmit(
            "This Aadhar number is already registered with another student.",
            "error",
          );
          return;
        }

        if (
          error.response.status === 409 &&
          error.response.data?.message ===
            "This student already exists with the same contact and details."
        ) {
          handleSubmit(
            "This student already exists with the same contact and details.",
            "error",
          );
          return;
        }

        if (
          error.response &&
          error.response.data &&
          error.response.data.details
        ) {
          if (error.response.data.details.includes("Validation error")) {
            setEmailError(true);
            handleSubmit(
              "This email is already registered. Please use a different email.",
              "error",
            );
          } else {
            console.error("Unknown error creating student:", error);
          }
        } else {
          console.error("Unhandled error:", error);
        }
      }
      // Call handleRowClick after successful OTP verification

      // Close the modal and reset form after OTP verification
      setIsOtpModalOpen(false);
      setOtp(["", "", "", "", "", ""]);
      setVerifyOTPMsg(""); // Clear any verification message
      setResendCount(0); // Reset resend count
      setResendTimer(600); // Reset resend timer
      setCanResend(true); // Disable resend button
    } else {
      setVerifyOTPMsg("Invalid OTP"); // Show this if the OTP is incorrect
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Focus on the next input
      if (value !== "" && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      // Focus on the previous input
      if (value === "" && index > 0) {
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) {
          prevInput.focus(); // Ensure focus happens only if the previous input exists
        }
      }
    }
  };

  // Add this useEffect to handle the countdown timer
  useEffect(() => {
    let intervalId;

    if (isOtpModalOpen && resendTimer > 0 && !canResend) {
      intervalId = setInterval(() => {
        setResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            clearInterval(intervalId);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isOtpModalOpen, canResend, resendTimer]);

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  const handleResendOtp = () => {
    if (canResend && resendCount < 3) {
      setResendCount((prev) => prev + 1);
      handleGetOtp(); // Triggers OTP generation and email
      setCanResend(false); // Disable until timer ends
      setResendTimer(600); // Restart the timer
    } else {
      setVerifyOTPMsg(
        "You have reached the maximum number of resend attempts.",
      );
    }
  };

  const handleCloseModal = () => {
    setIsOtpModalOpen(false);

    // Reset all states related to OTP input, verification, and timers
    setOtp(["", "", "", "", "", ""]); // Reset OTP fields
    setVerifyOTPMsg(""); // Clear any verification message
    setResendCount(0); // Reset resend count
    setResendTimer(600); // Reset resend timer
    setCanResend(true); // Disable resend button
  };

  useEffect(() => {
    const generateYears = () => {
      let yearsArray = [];
      for (let i = 0; i < 10; i++) {
        yearsArray.push(currentYear - i);
      }
      return yearsArray;
    };
    setYears(generateYears());
  }, [currentYear]);



  const handleFileUrlChange = (fileUrls) => {
    setSelectedDocuments(fileUrls);
  };

  const saveStudent = async () => {
    // e.preventDefault();
    // handleVerifyOtp();
    //Simran Added Snackbar
    if (formData.contact_no?.length < 10) {
      handleSubmit(
        "Invalid Contact number. Please enter at least 10 digits.",
        "error",
      );

      return;
    }

    if (formData.father_contact_no?.length < 10) {
      handleSubmit(
        "Invalid Father contact number. Please enter at least 10 digits.",
        "error",
      );
      return;
    }

    if (formData.mother_contact_no?.length < 10) {
      handleSubmit(
        "Invalid Mother contact number. Please enter at least 10 digits.",
        "error",
      );
      return;
    }

    if (formData.guardian_contact_no?.length < 10) {
      handleSubmit(
        "Invalid Guardian contact number. Please enter at least 10 digits.",
        "error",
      );

      return;
    }

    if (formData.student_aadhar_no?.length < 12) {
      handleSubmit(
        "Invalid Student Aadhar Number. Please enter atleast 12 digits.",
        "error",
      );
      return;
    }

    if (formData.father_aadhar_no?.length < 12) {
      handleSubmit(
        "Invalid Father Aadhar Number. Please enter atleast 12 digits.",
        "error",
      );
      return;
    }

    if (formData.mother_aadhar_no?.length < 12) {
      handleSubmit(
        "Invalid Mother Aadhar Number. Please enter atleast 12 digits.",
        "error",
      );
      return;
    }

    if (formData.guardian_aadhar_no?.length < 12) {
      handleSubmit(
        "Invalid Guardian Aadhar Number. Please enter atleast 12 digits.",
        "error",
      );
      return;
    }
    if (formData.apaar_id?.length < 12) {
      handleSubmit(
        "Invalid APAAR ID. Please enter atleast 12 digits.",
        "error",
      );
      return;
    }

    if (
      !formData.first_name &&
      !formData.last_name &&
      !formData.date_of_birth &&
      !formData.gender &&
      !formData.grade_id &&
      !formData.contact_no &&
      !formData.fee_slab_id
    ) {
      setFirstNameError(true);
      setLastNameError(true);
      setDobError(true);
      setGenderError(true);
      setFeeSlabError(true);
      setGradeError(true);
      setMobileNoError(true);
      handleSubmit("Please fill the mandatory fields", "error");
      return;
    }

    if (formData.email_id) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(formData.email_id)) {
        setEmailError(true);
        handleSubmit("Invalid email format.", "error");
        return;
      }
    }

    if (!formData.first_name) {
      setFirstNameError(true);
      handleSubmit("First Name cannot be empty.", "error");
      return;
    }
    if (!formData.last_name) {
      setLastNameError(true);
      handleSubmit("Last Name cannot be empty.", "error");
      return;
    }
    if (!formData.date_of_birth) {
      setDobError(true);
      handleSubmit("Date of birth cannot be empty.", "error");
      return;
    }
    if (!formData.gender) {
      setGenderError(true);
      handleSubmit("Gender cannot be empty.", "error");
      return;
    }
    if (!formData.fee_slab_id) {
      setFeeSlabError(true);
      handleSubmit("Fee Slab cannot be empty.", "error");
      return;
    }
    if (!formData.grade_id) {
      setGradeError(true);
      handleSubmit("Grade cannot be empty.", "error");

      return;
    }
    if (!formData.contact_no) {
      setMobileNoError(true);
      handleSubmit("Mobile No cannot be empty.", "error");
      return;
    }
    const studentRole = roles.find((r) => r.role_name === "Student");
    const combinedData = {
      ...formData,
      address: addressData,
      documents: selectedDocuments,
      role_id: studentRole ? studentRole.role_id : null, // Set role_id based on the "Student" role
      academic_year_id: academicYearId,
      created_by: userId,
      year_of_admission: currentYear,
    };

    console.log("Form Values:", combinedData);
    setLoading(true);
    await axios
      .post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/student/save-student",
        combinedData,
        { withCredentials: true },
      )
      .then((response) => {
        if (response.status === 401) {
          console.warn("Unauthorized access. Redirecting to Sign In...");
          navigate("/signin");
          return; // Stop further execution
        }
        console.log("Student created successfully:", response.data);
        if (studentData) {
          handleSubmit("Student Updated Successfully", "success");
        } else {
          handleSubmit("Student Created Successfully", "success");
        }

        reset();
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            // Use error.response.status instead of response.status
            console.warn("Unauthorized access. Redirecting to Sign In...");
            navigate("/signin"); // Fixed typo in "/signin"
            return;
          }
          if (
            error.response.status === 409 &&
            error.response.data?.message ===
              "This Aadhar number is already registered with another student."
          ) {
            handleSubmit(
              "This Aadhar number is already registered with another student.",
              "error",
            );
            return;
          }
          // Custom backend error message for duplicate student
          if (
            error.response.status === 409 &&
            error.response.data?.message === "This student already exists."
          ) {
            handleSubmit("This student already exists.", "error");
            return;
          }

          if (error.response.data && error.response.data.details) {
            if (error.response.data.details.includes("Validation error")) {
              setEmailError(true);
              handleSubmit(
                "This email is already registered. Please use a different email.",
                "error",
              );
            } else {
              console.error("Error creating student:", error);
            }
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //Done by Simran
  //removed refresh
  const reset = () => {
    onClose();
    fetchStudnt();
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (studentData) {
      setFormData(studentData);
      console.log(studentData);
    }
  }, [studentData]);

  //Field Added Part
  const handleInputChange = (event) => {
    setFirstNameError(false);
    setLastNameError(false);
    setDobError(false);
    if (dobError === false) {
      setBorderColor("#0A64A2");
    }
    setGenderError(false);
    setGradeError(false);
    setMobileNoError(false);
    setFeeSlabError(false);
    const { name, value } = event.target;
    let newValue = value;
    if (
      [
        "contact_no",
        "father_contact_no",
        "mother_contact_no",
        "guardian_contact_no",
      ].includes(name)
    ) {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10);
      }
    }

    if (name === "gr_number" && newValue.length > 10) {
      newValue = newValue.slice(0, 10); // Limit to 10 characters (any type)
    }

    if (
      [
        "student_aadhar_no",
        "father_aadhar_no",
        "mother_aadhar_no",
        "guardian_aadhar_no",
        "apaar_id",
      ].includes(name)
    ) {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 12) {
        newValue = newValue.slice(0, 12);
      }
    }
    if (["sat_no", "pen_no"].includes(name)) {
      if (newValue.length > 20) {
        newValue = newValue.slice(0, 20);
      }
    }

    // Set value to null if it is empty or a negative number
    if (newValue === "" || parseFloat(newValue) < 0) {
      newValue = null;
    }
    setFormData((formData) => ({
      ...formData,
      [name]: newValue,
    }));
  };

  useEffect(() => {
    let selectedGrade1 = grades.find((gr) => formData.grade_id === gr.grade_id);
    if (selectedGrade1) {
      let selectedGrade = selectedGrade1.grade_name;
      setSelectedGradeName(selectedGrade);
    }

    // Grade Admission
    let selectedGradeAdmission1 = gradeAdmission.find(
      (gr) => formData.grade_of_admission === gr.grade_id,
    );
    // Access the grade_name from the found grade object
    if (selectedGradeAdmission1) {
      let selectedGradeAdmission = selectedGradeAdmission1.grade_name; // Fallback if grade is not found
      setSelectedGradeAdmissionName(selectedGradeAdmission);
    }

    //Section
    let selectedSection1 = sections.find(
      (sc) => formData.section_id === sc.section_id,
    );
    // Access the grade_name from the found grade object
    if (selectedSection1) {
      let selectedSection = selectedSection1.section_name; // Fallback if grade is not found
      setSelectedSectionName(selectedSection);
    }

    //Fees Slab
    let selectedFeesSlab1 = feeSlab.find(
      (fs) => formData.fee_slab_id === fs.fees_slab_id,
    );
    // Access the grade_name from the found grade object
    if (selectedFeesSlab1) {
      let selectedFeesSlab = selectedFeesSlab1.fees_slab; // Fallback if grade is not found
      setSelectedFeesSlabName(selectedFeesSlab);
    }

    //TransportSlab
    let selectedTransportSlab = transportFees.find(
      (fs) => formData.transport_slab_id === fs.transport_slab_id,
    );
    // Access the grade_name from the found grade object
    if (selectedTransportSlab) {
      let selectedTransportSlabAmount =
        selectedTransportSlab.transport_slab_name; // Fallback if grade is not found
      setSelectedTransportSlab(selectedTransportSlabAmount);
    }
  }, [formData]);

  return (
    <div>
      <Box
        open={open}
        onClose={handleClose}
        sx={style}
        style={{ border: "none" }}
      >
        <Typography style={{ textAlign: "right" }}>
          <CloseIcon style={{ cursor: "pointer" }} onClick={onClose} />
        </Typography>

        <Typography
          sx={{ color: "#0A64A2" }}
          id="modal-modal-title"
          variant="h6"
          component="h2"
        >
          <PersonAddIcon /> {studentData ? `Edit Student` : `Add Student`}
        </Typography>
        <Divider style={{ background: "#0A64A2" }} />
        <Box
          component="form"
          sx={{
            paddingTop: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          noValidate
          autoComplete="off"
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
              gap: 8,
              width: "100%",
            }}
          >
            <div>
              {/* Changes all the field and Updated with alignment,Spacing and all css updated*/}
              <TextField
                id="outlined-gr-no"
                label="GR No"
                fullWidth
                name="gr_number"
                value={formData.gr_number}
                onChange={handleInputChange}
                size="small"
                sx={inputBorder}
                type="text"
              />

              <TextField
                sx={inputBorder}
                labelId="select-admission-year-label"
                id="select-admission-year"
                size="small"
                fullWidth
                name="year_of_admission"
                label="Year Of Admission"
                value={formData.year_of_admission || currentYear}
                onChange={handleInputChange}
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>

              {/* Arohi updated this textfield */}
              <TextField
                fullWidth
                margin="dense"
                sx={{
                  ...inputBorder,
                  bottom: "10px",
                }}
                select
                labelId="select-grade_of_admission-label"
                id="select-grade_of_admission"
                value={formData.grade_of_admission || ""}
                onChange={handleInputChange}
                label="Grade Of Admission"
                name="grade_of_admission"
                size="small"
              >
                {gradeAdmission.map((grade) => (
                  <MenuItem key={grade.grade_id} value={grade.grade_id}>
                    {grade.grade_name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                id="outlined-first-name"
                label={
                  <div style={{ display: "flex" }}>
                    First Name
                    <Typography variant="inherit" color="red">
                      &nbsp;*
                    </Typography>
                  </div>
                }
                fullWidth
                name="first_name"
                error={firstNameError}
                value={formData.first_name}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "10px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
              <TextField
                id="outlined-middle-name"
                label="Middle Name"
                fullWidth
                name="middle_name"
                value={formData.middle_name}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "10px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
              <TextField
                id="outlined-last-name"
                label={
                  <div style={{ display: "flex" }}>
                    Last Name
                    <Typography variant="inherit" color="red">
                      &nbsp;*
                    </Typography>
                  </div>
                }
                fullWidth
                error={lastNameError}
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "10px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />

              <TextField
                required
                sx={{
                  ...inputBorder,
                  bottom: "16px",
                }}
                id="outlined-date_of_birth"
                size="small"
                fullWidth
                margin="dense"
                name="date_of_birth"
                label="Date of Birth"
                error={dobError}
                type="date"
                value={formData.date_of_birth}
                onChange={handleInputChange}
                inputProps={{ max: today }}
                InputLabelProps={{ shrink: true }}
              />
              {/*  //Field Added Part */}
              <TextField
                id="outlined-Place-Of-Birth"
                label="Place Of Birth"
                fullWidth
                name="place_of_birth"
                value={formData.place_of_birth}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "15px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
              <TextField
                fullWidth
                margin="dense"
                sx={{
                  ...inputBorder,
                  bottom: "22px",
                }}
                select
                error={genderError}
                labelId="select-gender-label"
                id="select-gender"
                value={formData.gender || ""}
                onChange={handleInputChange}
                label="Select Gender"
                name="gender"
                size="small"
                required
              >
                <MenuItem value="M">Male</MenuItem>
                <MenuItem value="F">Female</MenuItem>
              </TextField>

              <TextField
                id="outlined-caste"
                label="Caste"
                fullWidth
                name="caste"
                value={formData.caste}
                onChange={handleInputChange}
                sx={{
                  ...inputBorder,
                  bottom: "20px",
                }}
                size="small"
                inputProps={{
                  maxLength: 50,
                }}
              />
              <TextField
                error={mobileNoError}
                id="outlined-mobile-no"
                label={
                  <div style={{ display: "flex" }}>
                    Mobile No
                    <Typography variant="inherit" color="red">
                      &nbsp;*
                    </Typography>
                  </div>
                }
                fullWidth
                type="number"
                name="contact_no"
                value={formData.contact_no}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "18px",
                }}
              />
              <TextField
                id="outlined-email-id"
                label="Email ID"
                fullWidth
                name="email_id"
                value={formData.email_id}
                onChange={handleInputChange}
                error={emailError}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "18px",
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
            </div>
            <div>
              {/*  //Field Added Part */}
              <TextField
                fullWidth
                margin="dense"
                sx={{
                  ...inputBorder,
                  bottom: "8px",
                }}
                select
                labelId="select-rte"
                id="select-rte"
                value={formData.rte}
                // value={formData.rte === false ? "No" : "Yes"}
                onChange={handleInputChange}
                label="Select RTE"
                name="rte"
                size="small"
                defaultValue={false}
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </TextField>

              <TextField
                sx={{
                  ...inputBorder,
                  bottom: "7px",
                }}
                select
                fullWidth
                error={gradeError}
                labelId="select-grade-label"
                id="select-grade"
                value={formData.grade_id || ""}
                onChange={handleInputChange}
                label="Select Grade"
                name="grade_id"
                required
                size="small"
              >
                {grades.map((grade) => (
                  <MenuItem key={grade.grade_id} value={grade.grade_id}>
                    {grade.grade_name}
                  </MenuItem>
                ))}
              </TextField>

              <FormControl
                fullWidth
                sx={{
                  ...inputBorder,
                  bottom: "7px",
                }}
              >
                <InputLabel id="select-section-label" size="small">
                  Select Section
                </InputLabel>
                <Select
                  labelId="select-section-label"
                  id="select-section"
                  value={formData.section_id || ""}
                  onChange={handleInputChange}
                  label="Select Grade"
                  name="section_id"
                  size="small"
                  required
                >
                  {sections.map((sections) => (
                    <MenuItem
                      key={sections.section_id}
                      value={sections.section_id}
                    >
                      {sections.section_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth sx={{ ...inputBorder, bottom: "8px" }}>
                <InputLabel id="select-blood-group-label" size="small">
                  Select Blood Group
                </InputLabel>
                <Select
                  labelId="select-blood-group-label"
                  id="select-blood-group"
                  value={formData.blood_group || ""}
                  onChange={handleInputChange}
                  label="Select Blood Group"
                  name="blood_group"
                  size="small"
                >
                  <MenuItem value="A+">A+</MenuItem>
                  <MenuItem value="A-">A-</MenuItem>
                  <MenuItem value="B+">B+</MenuItem>
                  <MenuItem value="B-">B-</MenuItem>
                  <MenuItem value="AB+">AB+</MenuItem>
                  <MenuItem value="AB-">AB-</MenuItem>
                  <MenuItem value="O+">O+</MenuItem>
                  <MenuItem value="O-">O-</MenuItem>
                </Select>
              </FormControl>

              <TextField
                type="number"
                id="outlined-aadhaar-no"
                label="Aadhaar No"
                fullWidth
                name="student_aadhar_no"
                value={formData.student_aadhar_no}
                onChange={handleInputChange}
                size="small"
                sx={{ ...inputBorder, bottom: "8px" }}
              />

              <TextField
                id="outlined-sat-no"
                label="SAT No"
                fullWidth
                name="sat_no"
                value={formData.sat_no}
                onChange={handleInputChange}
                size="small"
                sx={{ ...inputBorder, bottom: "8px" }}
              />
              <TextField
                id="outlined-pen-no"
                label="PEN No"
                fullWidth
                name="pen_no"
                value={formData.pen_no}
                onChange={handleInputChange}
                size="small"
                sx={{ ...inputBorder, bottom: "8px" }}
              />
              {/* Simran ... added new field APAAR ID  */}
              <TextField
                id="outlined-apaar-id"
                label="APAAR ID"
                fullWidth
                name="apaar_id"
                value={formData.apaar_id}
                onChange={handleInputChange}
                size="small"
                sx={{ ...inputBorder, bottom: "5px" }}
                type="number"
              />
              <FormControl fullWidth sx={{ ...inputBorder, bottom: "5px" }}>
                <InputLabel
                  id="select-fee-slab-label"
                  size="small"
                  required
                  error={feeSlabError}
                >
                  Select Fee Slab
                </InputLabel>
                <Select
                  error={feeSlabError}
                  labelId="select-fee-slab-label"
                  id="select-fee-slab"
                  value={formData.fee_slab_id || ""}
                  onChange={handleInputChange}
                  label="Select Fee Slab"
                  name="fee_slab_id"
                  size="small"
                >
                  {feeSlab.map((feeSlab) => (
                    <MenuItem
                      key={feeSlab.fees_slab_id}
                      value={feeSlab.fees_slab_id}
                    >
                      {feeSlab.fees_slab}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ ...inputBorder, bottom: "5px" }}>
                <InputLabel id="select-transport-fees-label" size="small">
                  Select Transport Fees
                </InputLabel>
                <Select
                  labelId="select-transport-fees-label"
                  id="select-transport-fees"
                  value={formData.transport_slab_id || ""}
                  onChange={handleInputChange}
                  label="Select Transport Fees"
                  name="transport_slab_id"
                  size="small"
                >
                  {transportFees.map((fees) => (
                    <MenuItem
                      key={fees.transport_slab_id}
                      value={fees.transport_slab_id}
                    >
                      {fees.transport_slab_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/*  //Field Added Part */}
              <TextField
                id="outlined-Mother-Tongue"
                label="Mother Tongue"
                fullWidth
                name="mother_tongue"
                value={formData.mother_tongue}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "3px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(
                      /[^a-zA-Z\s/-]/g,
                      "",
                    );
                  },
                }}
              />
              {/*  //Field Added Part */}
              <TextField
                id="outlined-Nationality"
                label="Nationality"
                fullWidth
                name="nationality"
                value={formData.nationality}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  bottom: "3px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
            </div>

            <div>
              <TextField
                id="outlined-father-name"
                label="Father Name"
                fullWidth
                name="father_name"
                value={formData.father_name}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  top: "1.8px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
              <TextField
                id="outlined-father-occupation"
                label="Father Occupation"
                fullWidth
                name="father_occupation"
                value={formData.father_occupation}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  top: "1.8px",
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
              <TextField
                id="outlined-father-aadhaar-no"
                label="Father Aadhaar No"
                fullWidth
                name="father_aadhar_no"
                value={formData.father_aadhar_no}
                onChange={handleInputChange}
                size="small"
                sx={inputBorder}
                type="number"
              />

              <TextField
                id="outlined-father-phone-no"
                label="Father Phone No"
                fullWidth
                name="father_contact_no"
                value={formData.father_contact_no}
                onChange={handleInputChange}
                size="small"
                sx={inputBorder}
                type="number"
              />

              <TextField
                id="outlined-mother-name"
                label="Mother Name"
                fullWidth
                name="mother_name"
                value={formData.mother_name}
                onChange={handleInputChange}
                size="small"
                sx={inputBorder}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
              <TextField
                id="outlined-mother-occupation"
                label="Mother Occupation"
                fullWidth
                name="mother_occupation"
                value={formData.mother_occupation}
                onChange={handleInputChange}
                size="small"
                sx={inputBorder}
                inputProps={{
                  maxLength: 50,
                }}
              />
              <TextField
                id="outlined-mother-aadhaar-no"
                label="Mother Aadhaar No"
                fullWidth
                name="mother_aadhar_no"
                value={formData.mother_aadhar_no}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  top: "2px",
                }}
                type="number"
              />
              <TextField
                id="outlined-mother-phone-no"
                label="Mother Phone No"
                fullWidth
                name="mother_contact_no"
                value={formData.mother_contact_no}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  top: "2px",
                }}
                type="number"
              />
              <TextField
                id="outlined-guardian-name"
                label="Guardian Name"
                fullWidth
                name="guardian_name"
                value={formData.guardian_name}
                onChange={handleInputChange}
                size="small"
                // sx={inputBorder}
                sx={{
                  ...inputBorder,
                  top: "2px",
                }}
                inputProps={{
                  maxLength: 50,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                  },
                }}
              />
              <TextField
                id="outlined-guardian-occupation"
                label="Guardian Occupation"
                fullWidth
                name="guardian_occupation"
                value={formData.guardian_occupation}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  top: "2px",
                }}
                inputProps={{
                  maxLength: 50,
                }}
              />
              <TextField
                id="outlined-guardian-aadhaar-no"
                label="Guardian Aadhaar No"
                fullWidth
                name="guardian_aadhar_no"
                value={formData.guardian_aadhar_no}
                onChange={handleInputChange}
                size="small"
                sx={{
                  ...inputBorder,
                  top: "2px",
                }}
                type="number"
              />
              <TextField
                id="outlined-guardian-phone-no"
                label="Guardian Phone No"
                fullWidth
                name="guardian_contact_no"
                value={formData.guardian_contact_no}
                onChange={handleInputChange}
                size="small"
                // sx={inputBorder}
                sx={{
                  ...inputBorder,
                  top: "2px",
                }}
                type="number"
              />

              {/* end */}
            </div>
            <div>
              <FormAddress
                onFileUrlChange={handleFileUrlChange}
                addressEdit={studentData ? studentData.addresses : null}
                studentDoc={studentData ? studentData.documents : null}
                addressData={addressData}
                setAddressData={setAddressData}
                setAddressFlag1={setAddressFlag1}
                setAddressFlag2={setAddressFlag2}
                setAddressFlag3={setAddressFlag3}
                setDocumentFlag1={setDocumentFlag1}
                setDocumentFlag2={setDocumentFlag2}
                setDocumentFlag3={setDocumentFlag3}
                setDocumentFlag4={setDocumentFlag4}
                setDocumentFlag5={setDocumentFlag5}
                setDocumentFlag6={setDocumentFlag6}
                setDocumentFlag7={setDocumentFlag7}
                setDocumentFlag8={setDocumentFlag8}
                setDocumentFlag9={setDocumentFlag9}
                setDocumentFlag10={setDocumentFlag10}
                setDocumentFlag11={setDocumentFlag11}
              />
              <TextField
                id="outlined-remarks"
                label="Remarks"
                placeholder="Remarks"
                multiline
                rows={4}
                fullWidth
                sx={{
                  mt: 1,
                  pt: 0,
                  pb: 0,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: `1px solid ${borderColor}`,
                    },
                  },
                }}
                name="remarks"
                borderColor
                value={formData.remarks}
                size="small"
                onChange={handleInputChange}
                inputProps={{ maxLength: 200 }}
              />

              <Button
                className="save_update_btn"
                style={{ float: "right" }}
                disable={loading}
                onClick={() => {
                  if (studentData) {
                    if (formData.contact_no?.length < 10) {
                      handleSubmit(
                        "Invalid Contact number. Please enter at least 10 digits.",
                        "error",
                      );
                      return;
                    }

                    if (formData.father_contact_no?.length < 10) {
                      handleSubmit(
                        "Invalid Father contact number. Please enter at least 10 digits.",
                        "error",
                      );
                      return;
                    }

                    if (formData.mother_contact_no?.length < 10) {
                      handleSubmit(
                        "Invalid Mother contact number. Please enter at least 10 digits.",
                        "error",
                      );
                      return;
                    }

                    if (formData.guardian_contact_no?.length < 10) {
                      handleSubmit(
                        "Invalid Guardian contact number. Please enter at least 10 digits.",
                        "error",
                      );

                      return;
                    }

                    if (formData.student_aadhar_no?.length < 12) {
                      handleSubmit(
                        "Invalid Student Aadhar Number. Please enter atleast 12 digits.",
                        "error",
                      );
                      return;
                    }

                    if (formData.father_aadhar_no?.length < 12) {
                      handleSubmit(
                        "Invalid Father Aadhar Number. Please enter atleast 12 digits.",
                        "error",
                      );
                      return;
                    }

                    if (formData.mother_aadhar_no?.length < 12) {
                      handleSubmit(
                        "Invalid Mother Aadhar Number. Please enter atleast 12 digits.",
                        "error",
                      );
                      return;
                    }

                    if (formData.guardian_aadhar_no?.length < 12) {
                      handleSubmit(
                        "Invalid Guardian Aadhar Number. Please enter atleast 12 digits.",
                        "error",
                      );
                      return;
                    }
                    if (formData.apaar_id?.length < 12) {
                      handleSubmit(
                        "Invalid APAAR ID. Please enter atleast 12 digits.",
                        "error",
                      );
                      return;
                    }

                    if (
                      !formData.first_name &&
                      !formData.last_name &&
                      !formData.date_of_birth &&
                      !formData.gender &&
                      !formData.grade_id &&
                      !formData.contact_no &&
                      !formData.fee_slab_id
                    ) {
                      setFirstNameError(true);
                      setLastNameError(true);
                      setDobError(true);
                      setGenderError(true);
                      setFeeSlabError(true);
                      setGradeError(true);
                      setMobileNoError(true);
                      handleSubmit("Please fill the mandatory fields", "error");
                      return;
                    }

                    if (formData.email_id) {
                      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                      if (!emailPattern.test(formData.email_id)) {
                        setEmailError(true);
                        handleSubmit("Invalid email format.", "error");
                        return;
                      }
                    }

                    if (!formData.first_name) {
                      setFirstNameError(true);
                      handleSubmit("First Name cannot be empty.", "error");
                      return;
                    }
                    if (!formData.last_name) {
                      setLastNameError(true);
                      handleSubmit("Last Name cannot be empty.", "error");
                      return;
                    }
                    if (!formData.date_of_birth) {
                      setDobError(true);
                      handleSubmit("Date of birth cannot be empty.", "error");
                      return;
                    }
                    if (!formData.gender) {
                      setGenderError(true);
                      handleSubmit("Gender cannot be empty.", "error");
                      return;
                    }
                    if (!formData.fee_slab_id) {
                      setFeeSlabError(true);
                      handleSubmit("Fee Slab cannot be empty.", "error");
                      return;
                    }
                    if (!formData.grade_id) {
                      setGradeError(true);
                      handleSubmit("Grade cannot be empty.", "error");

                      return;
                    }
                    if (!formData.contact_no) {
                      setMobileNoError(true);
                      handleSubmit("Mobile No cannot be empty.", "error");
                      return;
                    }
                    handleGetOtp();
                    // setSnackbarMessage("OTP sent successfully.");
                    // setSnackbarMessageColor("success");
                    // setShowSnackbarMessage(true);
                  } else {
                    saveStudent();
                  }
                }}
                variant="contained"
                sx={{ mt: 2 }}
              >
                {loading ? "Saving..." : studentData ? `Update` : `Save`}
              </Button>
            </div>
          </Box>
        </Box>
      </Box>

      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
        // action={action}>
      >
        <Alert
          // onClose={handleClose}
          severity={snackbarMessageColor}
          variant="filled"
          className="alert"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
        <Box className="modalStyle">
          {/* Close Button in the top-right corner */}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            style={{ position: "absolute", top: 7, right: 10 }}
          >
            <CloseIcon />
          </IconButton>

          <h3 className="enter-otp">Enter OTP</h3>
          <Divider className="divider" />
          {verifyOTPMsg && <p className="invalid-otp">{verifyOTPMsg}</p>}

          {/* OTP Input Boxes */}
          <div className="otp-container">
            {otp.map((data, index) => (
              <TextField
                autoFocus={index === 0}
                key={index}
                value={data}
                onChange={(e) => handleOtpChange(e, index)}
                inputProps={{
                  maxLength: 1,
                  id: `otp-input-${index}`, // Set id for focus management
                  style: {
                    textAlign: "center", // Center the text inside
                    fontSize: "17px", // Font size adjustment
                    width: "40px", // Set width and height equal to make it square
                    height: "40px", // Set width and height equal to make it square
                    padding: 0, // Remove default padding
                    boxSizing: "border-box", // Ensure borders don't affect the box size
                  },
                }}
                InputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: 0, // Remove extra padding to keep it square
                  },
                }}
              />
            ))}
          </div>

          {/* Verify and Resend OTP Message */}
          <div className="otp-btn-container">
            {/* Resend OTP Control */}
            {canResend ? (
              <p
                className="resend-otp"
                style={{ color: "green", cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                Resend OTP {resendCount}/3
              </p>
            ) : (
              <p style={{ color: "red" }}>
                Resend OTP in {formatTime(resendTimer)}
              </p>
            )}

            <Button
              variant="contained"
              onClick={handleVerifyOtp} // Use handleVerifyOtp for verification
              className="verify-btn"
            >
              Verify
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}